module.exports = __webpack_public_path__ + "img/image7.6c8b19e3.jpg";